import {
	SCHEMA_ANY_COMP_PROP,
	SCHEMA_BOOL_COMP_PROP,
	SCHEMA_STRING_COMP_PROP,
} from '../../constants';
import {
	ComponentPropertyDefinition,
	ComponentPropertyGroup,
	ComponentStylePropertyDefinition,
} from '../../types/common';
import { COMMON_COMPONENT_PROPERTIES, COMPONENT_STYLE_GROUP_PROPERTIES } from '../util/properties';

const propertiesDefinition: Array<ComponentPropertyDefinition> = [
	COMMON_COMPONENT_PROPERTIES.analyticsLabel,
	COMMON_COMPONENT_PROPERTIES.onClick,
	COMMON_COMPONENT_PROPERTIES.readOnly,
	COMMON_COMPONENT_PROPERTIES.visibility,
	COMMON_COMPONENT_PROPERTIES.colorScheme,
	{
		name: 'buttonBarDesign',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Button Bar Design',
		description: 'Color Scheme',
		defaultValue: '_buttonBarDesign1',
		group: ComponentPropertyGroup.BASIC,
		enumValues: [
			{
				name: '_buttonBarDesign1',
				displayName: 'Button Bar Design 1',
				description: 'Button Bar Design 1',
			},
			{
				name: '_buttonBarDesign2',
				displayName: 'Button Bar Design 2',
				description: 'Button Bar Design 2',
			},
			{
				name: '_buttonBarDesign3',
				displayName: 'Button Bar Design 3',
				description: 'Button Bar Design 3',
			},
			{
				name: '_buttonBarDesign4',
				displayName: 'Button Bar Design 4',
				description: 'Button Bar Design 4',
			},
		],
	},
	{
		name: 'label',
		schema: SCHEMA_ANY_COMP_PROP,
		displayName: 'Button Bar Label',
		group: ComponentPropertyGroup.BASIC,
		description: "Label that's shown on top of button bar input.",
	},

	{
		name: 'isMultiSelect',
		schema: SCHEMA_BOOL_COMP_PROP,
		group: ComponentPropertyGroup.ADVANCED,
		displayName: 'Multiple Selection Allowed ?',
		description: 'Allows the users to select multiple buttons.',
		defaultValue: false,
	},
	{
		name: 'data',
		schema: SCHEMA_ANY_COMP_PROP,
		group: ComponentPropertyGroup.DATA,
		displayName: 'ButtonBar data',
		description:
			'Data that is used to render ButtonBar, you can either give a value or expression, please read documentation for more information on Expressions.',
	},

	COMMON_COMPONENT_PROPERTIES.datatype,
	COMMON_COMPONENT_PROPERTIES.uniqueKeyType,
	COMMON_COMPONENT_PROPERTIES.selectionType,
	COMMON_COMPONENT_PROPERTIES.labelKeyType,
	COMMON_COMPONENT_PROPERTIES.selectionKey,
	COMMON_COMPONENT_PROPERTIES.uniqueKey,
	COMMON_COMPONENT_PROPERTIES.labelKey,
];
const stylePropertiesDefinition: ComponentStylePropertyDefinition = {
	'': [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	label: [
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
	],
	container: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	button: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
};
export { propertiesDefinition, stylePropertiesDefinition };
